<div class="header" >
  <div class="content">
    <div class="contentInner">
      <div class="pageTitle" appReveal>
        <h1 class="headline">Data deletion</h1>
      </div>
    </div>
  </div>
</div>
<div class="content">
  <div class="contentInner">
    <h2 class="sectionHeader">What data does Dash collect?</h2>
    <p>Dash takes your privacy seriously, so we only collect the minimum amount of information necessary to provide the
      Dash Meeting Room Display service to you.  For information about how this data is used, we encourage you to review
      our <a routerLink="/privacy-policy">privacy policy</a>.  The following is a list of all the data we collect from
      the Dash app:</p>

    <h3>For all versions of Dash</h3>
    <p>Including Dash Free, Dash Business, and Dash Enterprise.  This information is used to help us understand how our
      customers are using Dash and provide relevant updates and improvements to Dash.  The data is collected for each
      device you use with Dash</p>
    <ul>
      <li><b>App Interactions - </b>This includes information about what settings are chosen (for example the displayed
        language, and which optional features are turned on or off).  It also includes basic app interactions (for
        example when a room is booked, or a meeting is extended or ended early).  This data never includes any
        information about your organization or your meetings.
      </li>
      <li><b>Crash logs - </b>This includes information about when the app crashes and the cause</li>
      <li><b>Basic device information - </b>This includes the device manufacturer and model, the version of Android or
        iOS that it is running and other basic information such as the screen size and resolution.</li>
    </ul>

    <h3>For paid versions of Dash</h3>
    <p>Including Dash Business, and Dash Enterprise.  This information is used to help you manage the devices in your
      license.  The data collected consists of the following information, and is used to give you a list of devices
      registered to your subscription:</p>
    <ul>
      <li><b>Device Name</b></li>
      <li><b>Device IP</b></li>
      <li><b>Calendar Name</b> (i.e. the name of the meeting room being displayed)</li>
    </ul>

    <h3>For Dash Enterprise customers using the web management dashboard</h3>
    <p>We collect the following information in the web dashboard for the purpose of centrally managing and configuring
      your Dash display devices.  Only information directly entered by you is stored.</p>
    <ul>
      <li><b>Any configuration information entered into the dashboard</b> - This information is sent to your dash devices
        so that they can be configured centrally from the web management dashboard</li>
      <li><b>Connection information to Microsoft 365 or Google Workspace (optional) - </b>If you choose to add connection
        information to the web management dashboard, then your Dash display devices can be configured to automatically
        connect to your Microsoft 365 or Google Workspace accounts for the purpose of reading your meeting information.
        This connection information is only stored on our servers and is sent to your display devices for use.  We never
        read any information from Microsoft 365 or Google Workspace on our servers.</li>
    </ul>

    <h2 class="sectionHeader">Deleting your data</h2>
    <p>If you no longer wish to use Dash and would like us to delete your data from our servers, you can request a data
      deletion by using our <a routerLink="/contact">contact us</a> form.</p>
    <p>If you are subscribed to Dash Business via the Google Play Store or Apple App Store, please include your
      subscription id (which you can find in your most recent subscription receipt email from the store).  </p>
    <p>If you are subscribed via a license key or our web management dashboard, please provide your license key or
      information about your web dashboard account.</p>
    <p>Providing this information will help us identify which information belongs to you and should be deleted.</p>
    <p class="buttonContainer">
      <a class="button" routerLink="/contact">Contact Us</a>
    </p>
  </div>
</div>
